<template>
  <div id="pagination">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    total: Number,
    pageSizes: {
      default: () => [20, 30, 50, 80, 150, 300],
      type: Array,
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.$emit("getNewData");
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$emit("getNewData");
    },
  },
  beforeDestroy() {
    this.currentPage = 1;
    this.pageSize = 20;
  },
};
</script>

<style>
#pagination {
  width: 100%;
  /* position: absolute;
  right: 0;
  bottom: 0;
  background-color: #f5f7fa; */
  display: flex;
  justify-content: flex-end;
  padding-right: 16px;
}
</style>
